export const routes =  (prefix = `morgue`) => [
    {
        path: `/${prefix}/admissions`,
        name: `${prefix}.admissions.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.admissions.index`,
                PageDescription: "Morgue: Admissions",
            },
        },
    },
];
